import React from 'react'

const ImageBottomless = ({click}) => {
  return (
    <img onClick={click} src='https://res.cloudinary.com/dpuasqaeb/image/upload/v1686678911/Work-Services/309330100_118381917779535_1536306956171542184_n_diftnx.jpg' alt="" className='imgBottomless'/>
  )
}

export default ImageBottomless
